import { Forms } from 'sites/types';

export const commonForms: Forms = {
  registration: [
    [{ name: 'firstName', type: 'input', required: true }],
    [{ name: 'lastName', type: 'input', required: true }],
    [{ name: 'email', type: 'input', inputType: 'email', required: true }],
    [{ name: 'password', type: 'password', required: true }],
    [{ name: 'emailList', type: 'checkbox' }],
    [{ name: 'tacOnCreateAccount', type: 'terms-and-conditions' }],
    [{ name: 'createAccount', type: 'button', buttonType: 'submit' }],
  ],
  registrationV2: [
    [{ name: 'firstName', type: 'input', required: true }],
    [{ name: 'lastName', type: 'input', required: true }],
    [{ name: 'email', type: 'input', inputType: 'email', required: true }],
    [{ name: 'password', type: 'password', required: true }],
    [{ name: 'emailList', type: 'checkbox' }],
    [{ name: 'tacOnCreateAccount', type: 'terms-and-conditions' }],
    [{ name: 'createAccountV2', type: 'button', buttonType: 'submit' }],
  ],
  orderLookUpReturns: [
    [
      {
        name: 'orderNo',
        type: 'input',
        inputType: 'text',
        required: true,
      },
    ],
    [{ name: 'orderEmail', type: 'input', inputType: 'email', required: true }],
    [
      {
        name: 'returnsOrderExplainerModal',
        type: 'text-to-modal',
        required: true,
      },
    ],
    [
      {
        name: 'submitButton',
        type: 'button',
        buttonType: 'submit',
      },
    ],
  ],
};
